import script from "./e-color-group.vue?vue&type=script&setup=true&lang=js"
export * from "./e-color-group.vue?vue&type=script&setup=true&lang=js"

import "./e-color-group.vue?vue&type=style&index=0&id=7497b892&scoped=true&lang=css"

import exportComponent from "../../../../../.tjp/v1/FEharBh6/xdkj/daping/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.20_vue@3.4.20_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7497b892"]])

export default __exports__